import * as React from "react";

export const LongFormTnc: React.FunctionComponent = () => {
  return (
    <section className="long-form-tnc">
      <p>
        <span>{`By clicking join, you are agreeing to the Bed Bath N’ Table Rewards loyalty program `}</span>
        <a href="/terms">{`Terms and Conditions`}</a>
        <span>{` and our `}</span>
        <a href="/privacy">{`Privacy Policy`}</a>
        <span>{`. If you have ticked the subscribe box, you are opting in to receive email and SMS communications.`}</span>
      </p>

      <p>
        {`To stop receiving communications from Bed Bath N’ Table, you can opt out at any time by logging into your account or after receiving an email or SMS communication.`}
      </p>
    </section>
  );
};
